const CryptoJS = require("crypto-js");
// const encryptionKey = process.env.VUE_APP_ENCRYPTION_KEY;
// const encryptionKeyKey = process.env.VUE_APP_ENCRYPTION_KEYKEY;
const encryptionKey = 'NLT2024DEV@)@$)#';
const encryptionKeyKey = "NLT2024PASS@)@$#";
// export
const encryptData = (textData) => {
    const key = CryptoJS.enc.Utf8.parse(encryptionKey);
    const iv = CryptoJS.enc.Utf8.parse(encryptionKey);
    const encrypted = CryptoJS.AES.encrypt(textData, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    const encryptedData = (encrypted.ciphertext).toString(CryptoJS.enc.Base64);
    return encryptedData;
}

// export
const encryptDataKey = (textData) => {
    const key = CryptoJS.enc.Utf8.parse(encryptionKeyKey);
    const iv = CryptoJS.enc.Utf8.parse(encryptionKeyKey);
    const encrypted = CryptoJS.AES.encrypt(textData, key, {
        iv: key,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    const encryptedData = encrypted?.ciphertext.toString(CryptoJS.enc.Base64);
    return encryptedData;
}

const generateRandomNumber = (minDigits) => {
    const minValue = Math.pow(10, minDigits - 1);
    const maxValue = Math.pow(10, minDigits) - 1;
    return Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue;
}


export const generateAPIKey = (keyCollectFromServer, keyCmpnID) => {
    // console.log(encryptionKey, encryptionKeyKey);
    const keyCompany = encryptDataKey('NLT');
    const time = new Date().toTimeString().slice(0, 8).replace(/:/g, '');
    const timmer = encryptDataKey(time);
    const server = encryptDataKey(keyCollectFromServer?.toString());
    const serverCmpnID = encryptDataKey(keyCmpnID?.toString());
    const MIN_DIGITS = 6;
    const randomNumber = generateRandomNumber(MIN_DIGITS);
    const randomText = encryptDataKey(randomNumber?.toString());
    const appCode = encryptDataKey('NLT_INFORMATION')
    const text = keyCompany + timmer + keyCompany + server + keyCompany + serverCmpnID + keyCompany + randomText + keyCompany + appCode;
    const textKey = encryptData(text);
    return textKey;
}

